import { Message } from '../../models/message';

export class SetMessages {
    public static readonly type = '[MessagingState] Set messages';

    constructor(public messages: Message[]) {}
}
